<template>
  <div class="steps" :class="modifiers">
    <div v-if="items.length" class="steps__items">
      <div
        v-for="(item, index) in items"
        :key="`step_${index}`"
        class="steps__item"
        :data-animation="animation"
        :data-animation-delay="(delay + (item.delay !== undefined ? item.delay : index) * itemDelay)"
      >
        <div class="steps__circle">
          {{ item.index ? item.index : index + 1 }}
        </div>
        <div class="steps__text">
          <BaseText v-bind="item.attrs" v-html="item.text" />
<!--           <BaseList
            v-if="item.list"
            v-bind="item.listAttrs"
            :items="item.list"
            :animation="''"
            class="steps__list"
          /> -->
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';
// import BaseList from '@/components/BaseList.vue';

export default {
  name: 'BaseSteps',
  components: {
    BaseText,
    // BaseList,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    animation: {
      type: String,
      default: 'fadeInBottom',
    },
    delay: {
      type: Number,
      default: 0,
    },
    itemDelay: {
      type: Number,
      default: 300,
    },
    // isClean: {
    //   type: Boolean,
    //   default: false,
    // },
    isDouble: {
      type: Boolean,
      default: false,
    },
    isTriple: {
      type: Boolean,
      default: false,
    },
    // isCircleFill: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  computed: {
    modifiers() {
      return {
        // steps_clean: this.isClean,
        steps_triple: this.isTriple,
        steps_double: this.isDouble,
        // steps_fill_circle: this.isCircleFill,
      };
    },
  },
};
</script>

<style lang="stylus">
.steps
  display block

  &__items
    ~/_double &
    ~/_triple &
      +landscape()
        display flex
        flex-wrap wrap
        justify-content space-between

  &__item
    display flex
    align-items center
    padding 1em//0.8em 0.7em
    background-color $c_bg//#fff
    //border 1px solid $c_border_bright
    border-radius 1em
    margin-top 1em
    &:first-child
      margin-top 0

    ~/_double &
      +landscape()
        flex 0 0 50%
        max-width calc(50% - 0.5em)
        margin 0
        &:not(:nth-child(-n+2))
          margin-top 1em

    ~/_triple &
      +landscape()
        flex 0 0 33.33333333%
        max-width calc(33.33333333% - 0.7em)
        margin 0
        &:not(:nth-child(-n+3))
          margin-top 3em

        // display inline-flex
        // vertical-align top
        // width 100%
        // margin-top 0
        // margin-bottom 1em

    // ~/_clean &
    //   padding 0
    //   background none
    //   border 0

  &__circle
    display flex
    align-items center
    justify-content center
    width 2em
    height @width
    font-size 1em
    font-weight 700
    color #fff
    text-align center
    background-color #567DF4
    //background-color #6C695D
    // border solid 2px currentColor
    box-shadow 0 0 0 0.25em #C9E7FF
    border-radius 50%
    // ~/_fill_circle &
    //   border-color transparent
    //   background-color $c_bright
    //   color #fff

  &__text
    flex 1
    min-width 0
    padding-left 1em
    align-self center
    color #6C695D
    &:first-child
      padding-left 0

  // &__list
  //   margin-top 0.7em
  //   // .list__item
  //   //   margin-top 0.5em
</style>
